import { render, staticRenderFns } from "./BaseModalCard.vue?vue&type=template&id=63b2ee9e&"
import script from "./BaseModalCard.vue?vue&type=script&lang=js&"
export * from "./BaseModalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports